import { render, staticRenderFns } from "./FreeBusy.vue?vue&type=template&id=7064880a&scoped=true"
import script from "./FreeBusy.vue?vue&type=script&lang=js"
export * from "./FreeBusy.vue?vue&type=script&lang=js"
import style0 from "./FreeBusy.vue?vue&type=style&index=0&id=7064880a&prod&lang=scss&scoped=true"
import style1 from "./FreeBusy.vue?vue&type=style&index=1&id=7064880a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064880a",
  null
  
)

export default component.exports